<template>
  <div class="full-height">
    <cars-header></cars-header>
    <intro></intro>
    <section-intro :title="$t('message.title.site.our_cars')"></section-intro>
    <car-list></car-list>
    <cars-footer></cars-footer>
  </div>
</template>

<script>
  import Intro from '../components/partials/IntroLarge'
  import CarsHeader from '../components/partials/Header'
  import CarsFooter from '../components/partials/Footer'
  import SectionIntro from '../components/partials/SectionIntro'
  import CarList from '../components/car/CarList'

  export default {
    components: {
      Intro, CarsHeader, CarsFooter, CarList, SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// Cars.vue?1da0181a